import CustomSearchDropdown from "../../POP/FileComp5";
import _ from "lodash";
import { useSearchParams } from "react-router-dom";
import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import TableCompoenent from "./TableCompoenent";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import { useDispatch, useSelector } from "react-redux";
import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
import DropDownCB from "../components/SingleDropdwon";
import FormInputs from "../DummyReportPage/FormInputs";
import dayjs from "dayjs";
import DropDownMultipleSelection from "../components/FieldsComponent";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Warning.png";
import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";
import { useNavigate } from "react-router-dom";

const mapDataToDropdownFormat = (dataArray, idField, nameField) => {
  return _.uniqBy(
    dataArray.map((item) => ({
      id: item[idField],
      label: item[nameField],
    })),
    "id"
  );
};

const IncompleteDppReport = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  pauseTimer,
  resumeTimer,
  dataClient,
  setPagePath,
}) => {
  const dispatch = useDispatch();
  const { coursesdata } = useSelector((state) => state.course);
  const [resultsData, setResultsData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [isApplied, setIsApplied] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [disabled, setDisabled] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  // Dropdown data states
  const [batchData, setBatchData] = useState([]);
  const [studentData, setStudentData] = useState([]);
  const [sessionData, setSessionData] = useState([]);
  const [dppData, setDppData] = useState([]);

  // Selected values states
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [selectedBatchId, setSelectedBatchId] = useState("");
  const [selectedSessionId, setSelectedSessionId] = useState("");
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [selectedDpps, setSelectedDpps] = useState([]);

  // Search states
  const [searchKey, setSearchKey] = useState("");
  const [searchColumn, setSearchColumn] = useState("");

  // Date range state
  const [value, setValues] = useState({
    month: "Month to Date",
    start_month: "",
    end_month: "",
  });

  const [searchParams] = useSearchParams();
  const reportName = searchParams.get("reportName") || "Incomplete DPP Report";

  const navigate = useNavigate();

  // Add this with other dropdown data states
  const [subjectData, setSubjectData] = useState([]);

  // Add this with other selected values states
  const [selectedSubjects, setSelectedSubjects] = useState([]);

  // Fetch subject data based on course
  const fetchSubjectData = async () => {
    try {
      if (!selectedCourseId) return;

      const response = await fetch(
        `${FULL_API_BASE_URL}/get-subjects-by-course/?course_id=${selectedCourseId}`,
        {
          method: "GET",
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();

      if (result && Array.isArray(result)) {
        const formattedSubjects = result.map((subject) => ({
          id: subject.subject_id,
          label: subject.subject_name,
        }));
        setSubjectData(formattedSubjects);
      }
    } catch (error) {
      console.error("Error fetching subject data:", error);
    }
  };

  useEffect(() => {
    setPagePath("Reports > Reports Dashboard > DPP Completion");
  }, []);

  // Fetch course data on mount
  useEffect(() => {
    dispatch(fetchCourseData());
  }, [dispatch]);

  // Fetch sessions on mount
  useEffect(() => {
    fetchSessionsData();
  }, []);

  // Fetch batch data when course changes
  useEffect(() => {
    if (selectedCourseId) {
      fetchBatchData();
      fetchSubjectData();
    }
    // Clear dependent dropdowns when course changes (except session - will be auto-set)
    setSelectedBatchId("");
    setSelectedStudents([]);
    setSelectedSubjects([]);
    setSelectedDpps([]);
    setBatchData([]);
    setSubjectData([]);
    setStudentData([]);
    setDppData([]);
  }, [selectedCourseId]);

  // Auto-select the most recent session (highest session_id) when course is selected
  useEffect(() => {
    if (selectedCourseId && sessionData.length > 0) {
      // Find the session with the highest session_id
      const mostRecentSession = sessionData.reduce((prev, current) =>
        prev.id > current.id ? prev : current
      );
      setSelectedSessionId(mostRecentSession.id);
    } else if (!selectedCourseId) {
      setSelectedSessionId("");
    }
  }, [selectedCourseId, sessionData]);

  // Clear batch, student, dpp when session changes
  useEffect(() => {
    setSelectedBatchId("");
    setSelectedStudents([]);
    setSelectedDpps([]);
    setSelectedSubjects([]);
    setStudentData([]);
    setDppData([]);
  }, [selectedSessionId]);

  // Fetch student data and DPP data when batch changes
  useEffect(() => {
    if (selectedCourseId && selectedBatchId) {
      fetchStudentData();
      fetchDppData();
    }
    // Clear dependent dropdowns when batch changes
    setSelectedStudents([]);
    setSelectedSubjects([]);
    setSelectedDpps([]);
    setStudentData([]);
    setDppData([]);
  }, [selectedBatchId]);

  // Filter batches based on selected session
  const filteredBatchData = useMemo(() => {
    if (!selectedSessionId) {
      return batchData;
    }
    return batchData.filter((batch) => batch.session_id === selectedSessionId);
  }, [batchData, selectedSessionId]);

  // Fetch sessions list
  const fetchSessionsData = async () => {
    try {
      const response = await fetch(`${FULL_API_BASE_URL}/get-sessions-list`, {
        method: "GET",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();

      if (result.status === 200 && result.data) {
        const formattedSessions = result.data.map((session) => ({
          id: session.session_id,
          label: session.session_name,
        }));
        setSessionData(formattedSessions);
      }
    } catch (error) {
      console.error("Error fetching sessions data:", error);
    }
  };

  // Fetch batch data based on course
  const fetchBatchData = async () => {
    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-batches-by-course/?course_id=${selectedCourseId}`,
        {
          method: "GET",
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (data && Array.isArray(data)) {
        const formattedBatches = data.map((item) => ({
          id: item.batch_id,
          label: item.batch_name,
          session_id: item.session_id,
          session_name: item.session_name,
        }));
        setBatchData(formattedBatches);
      }
    } catch (error) {
      console.error("Error fetching batch data:", error);
    }
  };

  // Fetch student data based on course and batch
  const fetchStudentData = useCallback(async () => {
    try {
      if (!selectedCourseId || !selectedBatchId) return;

      const response = await fetch(
        `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey-v2/?course_id=${selectedCourseId}`,
        {
          method: "POST",
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            batch_ids: [selectedBatchId],
            subject_ids: [],
            chapter_ids: [],
            assessment_ids: [],
            student_ids: [],
            search_key: searchKey,
            search_column: searchColumn,
          }),
        }
      );

      const data = await response.json();

      const uniqueStudents = _.uniqBy(data.student_list, "student_id");
      setStudentData(
        uniqueStudents.map((item) => ({
          id: item.student_id,
          student_name: item.student_name,
          roll_number: item.roll_number,
          batch_name: item.batch_name,
        }))
      );
    } catch (error) {
      console.error("Error fetching student data:", error);
    }
  }, [selectedCourseId, selectedBatchId, searchKey, searchColumn]);

  // Fetch DPP data based on batch only
  // const fetchDppData = async () => {
  //   try {
  //     if (!selectedBatchId) return;

  //     const response = await fetch(
  //       `${FULL_API_BASE_URL}/get-dpps-by-batch?batch_id=${selectedBatchId}`,
  //       {
  //         method: "GET",
  //         headers: {
  //           accept: "application/json",
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     const result = await response.json();

  //     if (result.status === 200 && result.data) {
  //       const formattedDpps = result.data
  //         .filter((dpp) => dpp.schedule_id)
  //         .map((dpp) => ({
  //           id: dpp.schedule_id,
  //           label: dpp.assessment_name,
  //         }));

  //       setDppData(_.uniqBy(formattedDpps, "id"));
  //     }
  //   } catch (error) {
  //     console.error("Error fetching DPP data:", error);
  //   }
  // };

  const fetchDppData = async () => {
    try {
      if (!selectedBatchId) return;

      const response = await fetch(
        `${FULL_API_BASE_URL}/get-dpps-by-batch?batch_id=${selectedBatchId}`,
        {
          method: "GET",
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();

      if (result.status === 200 && result.data) {
        const formattedDpps = result.data
          .filter((dpp) => dpp.schedule_id)
          .map((dpp) => ({
            id: dpp.schedule_id,
            label: dpp.assessment_name,
            subject_id: dpp.subject_id, // ← store subject_id
          }));

        setDppData(_.uniqBy(formattedDpps, "id"));
      }
    } catch (error) {
      console.error("Error fetching DPP data:", error);
    }
  };

  const filteredDppData = useMemo(() => {
    if (!selectedSubjects || selectedSubjects.length === 0) {
      return dppData;
    }
    return dppData.filter((dpp) => selectedSubjects.includes(dpp.subject_id));
  }, [dppData, selectedSubjects]);

  useEffect(() => {
    setSelectedDpps([]);
  }, [selectedSubjects]);

  const handleDropdownClose = () => {
    if (selectedCourseId && selectedBatchId) {
      fetchStudentData();
    }
  };

  const handleSearchKeyChange = (key, dropdownType) => {
    if (key.length >= 3 && dropdownType === "student") {
      setSearchKey(key);
      setSearchColumn(dropdownType);
    } else {
      setSearchKey("");
      setSearchColumn("");
    }
  };

  // Handle radio button click - allows deselection
  const handleRadioChange = (selectedValue) => {
    if (value.month === selectedValue) {
      setValues({ ...value, month: "" });
    } else {
      setValues({ ...value, month: selectedValue });
    }
  };

  // Calculate dates based on selected option
  const calculateDates = () => {
    const today = dayjs();
    let from_date = "";
    let end_date = "";

    if (!value.month) {
      return { from_date: "", end_date: "" };
    }

    end_date = today.format("YYYY-MM-DD");

    switch (value.month) {
      case "Last Month":
        from_date = today
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DD");
        end_date = today
          .subtract(1, "month")
          .endOf("month")
          .format("YYYY-MM-DD");
        break;
      case "Month to Date":
        from_date = today.startOf("month").format("YYYY-MM-DD");
        break;
      case "Week to Date":
        from_date = today.startOf("week").format("YYYY-MM-DD");
        break;
      case "Custom":
        from_date = value.start_month;
        end_date = value.end_month;
        break;
      default:
        from_date = "";
        end_date = "";
        break;
    }
    return { from_date, end_date };
  };

  const { from_date, end_date } = calculateDates();

  // Handle Apply/Reset button click
  // const handleApplyOrReset = async () => {
  //   if (isApplied) {
  //     setResultsData([]);
  //     setHeaders([]);
  //     setIsApplied(false);
  //     setIsColumnDivVisible(false);
  //     setDisabled(false);
  //     setResetKey((prevKey) => prevKey + 1);

  //     setValues((prevValues) => ({
  //       ...prevValues,
  //       month: prevValues.month,
  //       start_month: prevValues.start_month,
  //       end_month: prevValues.end_month,
  //     }));
  //   } else {
  //     // Validation: Check if required fields are selected
  //   if (!selectedCourseId || !selectedSessionId || !selectedBatchId) {
  //     const missingFields = [];
  //     if (!selectedCourseId) missingFields.push("Course");
  //     if (!selectedSessionId) missingFields.push("Session");
  //     if (!selectedBatchId) missingFields.push("Batch");

  //     const errorMessage = `Please select ${missingFields.join(", ")} before applying.`;

  //     setIsMessageBoxVisible(true);
  //     setMessageBox(
  //       <div
  //         className="Container-messageBOX"
  //         onMouseEnter={pauseTimer}
  //         onMouseLeave={resumeTimer}
  //       >
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>{errorMessage}</span>
  //         </div>
  //       </div>
  //     );
  //     setActiveImg(ErrorImg);
  //     return; // Exit early without making the API call
  //   }
  //     setIsApplied(true);
  //     setDisabled(true);

  //     const { from_date, end_date } = calculateDates();

  //     const requestBody = {};

  //     if (selectedBatchId) {
  //       requestBody.batch_ids = [selectedBatchId];
  //     }

  //     if (selectedStudents.length > 0) {
  //       requestBody.student_ids = selectedStudents;
  //     }

  //     if (selectedDpps.length > 0) {
  //       requestBody.dpp_schedule_ids = selectedDpps;
  //     }

  //     if (selectedSessionId) {
  //       requestBody.session_ids = [selectedSessionId];
  //     }

  //     if (from_date) {
  //       requestBody.from_date = from_date;
  //     }

  //     if (end_date) {
  //       requestBody.end_date = end_date;
  //     }

  //     try {
  //       const response = await fetch(
  //         `${FULL_API_BASE_URL}/incomplete-dpp-report`,
  //         {
  //           method: "POST",
  //           headers: {
  //             accept: "application/json",
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify(requestBody),
  //         }
  //       );

  //       const result = await response.json();

  //       if (result.status === 200 && result.data && result.data.length > 1) {
  //         setHeaders(result.data[0]);
  //         setResultsData(result.data.slice(1));
  //       } else {
  //         setResultsData([]);
  //         setIsMessageBoxVisible(true);
  //         setMessageBox(
  //           <div
  //             className="Container-messageBOX"
  //             onMouseEnter={pauseTimer}
  //             onMouseLeave={resumeTimer}
  //           >
  //             <div className="messagebox-insider1">
  //               <div className="loader-tc"></div>
  //               <span>No data found for the selected filters.</span>
  //             </div>
  //           </div>
  //         );
  //         setActiveImg(InterogativeImg);
  //       }
  //     } catch (error) {
  //       setResultsData([]);
  //       setIsMessageBoxVisible(true);
  //       setMessageBox(
  //         <div
  //           className="Container-messageBOX"
  //           onMouseEnter={pauseTimer}
  //           onMouseLeave={resumeTimer}
  //         >
  //           <div className="messagebox-insider1">
  //             <div className="loader-tc"></div>
  //             <span>{error.message || "Failed to generate report"}</span>
  //           </div>
  //         </div>
  //       );
  //       setActiveImg(ErrorImg);
  //     }
  //   }
  // };

  const [isLoading, setIsLoading] = useState(false);
  const slowLoadingTimerRef = useRef(null);

  const clearSlowTimer = () => {
    if (slowLoadingTimerRef.current) {
      clearTimeout(slowLoadingTimerRef.current);
      slowLoadingTimerRef.current = null;
    }
  };

  // Unmount par timer clear
  useEffect(() => {
    return () => clearSlowTimer();
  }, []);

  const handleApplyOrReset = async () => {
    if (isApplied) {
      clearSlowTimer();
      setResultsData([]);
      setHeaders([]);
      setIsApplied(false);
      setIsLoading(false);
      setIsColumnDivVisible(false);
      setDisabled(false);
      setIsMessageBoxVisible(false);
      setResetKey((prevKey) => prevKey + 1);

      setValues((prevValues) => ({
        ...prevValues,
        month: prevValues.month,
        start_month: prevValues.start_month,
        end_month: prevValues.end_month,
      }));
    } else {
      // Validation: Check if required fields are selected
      if (!selectedCourseId || !selectedSessionId || !selectedBatchId) {
        const missingFields = [];
        if (!selectedCourseId) missingFields.push("Course");
        if (!selectedSessionId) missingFields.push("Session");
        if (!selectedBatchId) missingFields.push("Batch");

        const errorMessage = `Please select ${missingFields.join(
          ", "
        )} before applying.`;

        setIsMessageBoxVisible(true);
        setMessageBox(
          <div
            className="Container-messageBOX"
            onMouseEnter={pauseTimer}
            onMouseLeave={resumeTimer}
          >
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{errorMessage}</span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        return;
      }

      // Show loading message
      setIsLoading(true);
      setIsApplied(true);
      setDisabled(true);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div
          className="Container-messageBOX"
          onMouseEnter={pauseTimer}
          onMouseLeave={resumeTimer}
        >
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Loading data, please wait...</span>
          </div>
        </div>
      );
      setActiveImg(false);

      // 5 sec baad "taking longer" message
      clearSlowTimer();
      slowLoadingTimerRef.current = setTimeout(() => {
        setMessageBox(
          <div
            className="Container-messageBOX"
            onMouseEnter={pauseTimer}
            onMouseLeave={resumeTimer}
          >
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                This is taking longer than usual, please wait a moment...
              </span>
            </div>
          </div>
        );
      }, 5000);

      const { from_date, end_date } = calculateDates();

      const requestBody = {};

      if (selectedBatchId) {
        requestBody.batch_ids = [selectedBatchId];
      }

      if (selectedStudents.length > 0) {
        requestBody.student_ids = selectedStudents;
      }

      if (selectedDpps.length > 0) {
        requestBody.dpp_schedule_ids = selectedDpps;
      }

      if (selectedSessionId) {
        requestBody.session_ids = [selectedSessionId];
      }

      if (from_date) {
        requestBody.from_date = from_date;
      }

      if (end_date) {
        requestBody.end_date = end_date;
      }

      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/incomplete-dpp-report`,
          {
            method: "POST",
            headers: {
              accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          }
        );

        const result = await response.json();
        clearSlowTimer();

        if (
          result.status === 200 &&
          result.data?.data &&
          result.data.data.length > 1
        ) {
          setHeaders(result.data.data[0]);
          setResultsData(result.data.data.slice(1));
          setIsLoading(false);
          setIsMessageBoxVisible(false);
        } else {
          setIsLoading(false);
          setResultsData([]);
          setIsMessageBoxVisible(true);
          setMessageBox(
            <div
              className="Container-messageBOX"
              onMouseEnter={pauseTimer}
              onMouseLeave={resumeTimer}
            >
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>No data found for the selected filters.</span>
              </div>
            </div>
          );
          setActiveImg(InterogativeImg);
        }
      } catch (error) {
        clearSlowTimer();
        setIsLoading(false);
        setResultsData([]);
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div
            className="Container-messageBOX"
            onMouseEnter={pauseTimer}
            onMouseLeave={resumeTimer}
          >
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{error.message || "Failed to generate report"}</span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
      }
    }
  };

  const dropdownStyle = isApplied
    ? { opacity: 0.5, pointerEvents: "none" }
    : { opacity: 1, pointerEvents: "auto" };

  const course =
    coursesdata && coursesdata.length > 0
      ? coursesdata.find((course) => course.course_id === selectedCourseId)
          ?.course_description || ""
      : "";

  const getSelectedBatchName = () => {
    if (!selectedBatchId) return "All";
    const batch = batchData.find((batch) => batch.id === selectedBatchId);
    return batch ? batch.label : "All";
  };

  const getSelectedStudentRollNumbers = () => {
    if (selectedStudents.length === 0) return "All";
    const rollNumbers = studentData
      .filter((student) => selectedStudents.includes(student.id))
      .map((student) => student.roll_number);
    const rollNumbersString = rollNumbers.join(", ");
    const maxLength = 129;
    if (rollNumbersString.length > maxLength) {
      return "Multiple";
    }
    return rollNumbersString;
  };

  const getSelectedSessionName = () => {
    if (!selectedSessionId) return "All";
    const session = sessionData.find(
      (session) => session.id === selectedSessionId
    );
    return session ? session.label : "All";
  };

  const getSelectedDppNames = () => {
    if (selectedDpps.length === 0) return "All";
    const dppNames = dppData
      .filter((dpp) => selectedDpps.includes(dpp.id))
      .map((dpp) => dpp.label);
    const dppNamesString = dppNames.join(", ");
    const maxLength = 129;
    if (dppNamesString.length > maxLength) {
      return "Multiple";
    }
    return dppNamesString;
  };

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "36.5px",
        marginBottom: "40px",
      }}
    >
      <div style={{ position: "sticky", top: "0" }}>
        <div className="Header-up">
          <span
            style={{
              color: "#2F2E40",
              fontSize: "30px",
              textTransform: "capitalize",
            }}
          >
            {reportName}
          </span>
          <div
            className="testreportcard-header-btn-container"
            style={{ marginRight: "30px" }}
          >
            <button
              className="testreportcard-cancel-btn"
              onClick={() => {
                navigate("/report_management");
                setPagePath("Reports > Reports Dashboard");
              }}
            >
              CANCEL
            </button>

            <button
              className="testreportcard-create-btn"
              onClick={handleApplyOrReset}
              // style={{
              //   opacity: isLoading ? 0.6 : 1,
              //   cursor: isLoading ? "not-allowed" : "pointer",
              // }}
            >
              {isApplied ? "RESET" : "APPLY"}
            </button>
          </div>
        </div>
      </div>

      <div style={{ display: isVisible ? "block" : "none", marginTop: "1vh" }}>
        {/* Row 1: Course, Session, Batch */}
        <div className="row-cs-uni">
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`course_${resetKey}`}
          >
            <DropDownCB
              label="Course"
              style={{ width: "13.5vw" }}
              selected={selectedCourseId}
              setSelected={setSelectedCourseId}
              options={
                coursesdata
                  ? coursesdata.map((course) => ({
                      id: course.course_id,
                      label: course.course_description,
                    }))
                  : []
              }
              isRequired={true}
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`session_${resetKey}`}
          >
            <DropDownCB
              label="Select Session"
              style={{ width: "13.5vw" }}
              selected={selectedSessionId}
              setSelected={setSelectedSessionId}
              options={sessionData}
              isRequired={true}
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`batch_${resetKey}`}
          >
            <DropDownCB
              label="Select Batch"
              style={{ width: "13.5vw" }}
              selected={selectedBatchId}
              setSelected={setSelectedBatchId}
              options={filteredBatchData}
              disabled={!selectedCourseId}
              isRequired={true}
            />
          </div>
        </div>

        {/* Row 2: Student, DPP */}
        <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`subject_${resetKey}`}
          >
            <DropDownMultipleSelection
              width="13.5vw"
              label="Select Subject"
              selected={selectedSubjects}
              setSelected={setSelectedSubjects}
              options={subjectData}
              customWidth="100%"
              isRequired={false}
              showSelectAll={true}
              onDropdownClose={() => {}}
              disabled={!selectedCourseId}
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`student_${resetKey}`}
          >
            <CustomSearchDropdown
              label="Select Student"
              optionsData={studentData}
              selected={selectedStudents}
              setSelected={setSelectedStudents}
              placeholder="Search for Students..."
              headers={["Student Name", "Roll Number", "Batch Name"]}
              optionFields={{
                option1: "student_name",
                option2: "roll_number",
                option3: "batch_name",
              }}
              onDropdownClose={handleDropdownClose}
              onSearchKeyChange={(key) => handleSearchKeyChange(key, "student")}
              customwidth="25vw"
              dropdownWidth="13.5vw"
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`dpp_${resetKey}`}
          >
            <DropDownMultipleSelection
              width="13.5vw"
              label="Select DPP"
              selected={selectedDpps}
              setSelected={setSelectedDpps}
              // options={dppData}
              options={filteredDppData}
              customWidth="100%"
              isRequired={false}
              showSelectAll={true}
              onDropdownClose={() => {}}
              disabled={!selectedBatchId}
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
          >
            {/* Empty placeholder */}
          </div>
        </div>

        {/* Row 3: Date Range Radio Buttons */}
        <div
          className="grid-container-radio-button"
          style={{ marginTop: "1vh", height: "35px", ...dropdownStyle }}
        >
          <div className="item5">
            <div className="toggle-radio">
              <input
                type="radio"
                id="last month"
                name="month"
                value="Last Month"
                checked={value.month === "Last Month"}
                onClick={() => handleRadioChange("Last Month")}
                onChange={() => {}}
                disabled={isApplied}
              />
              <label htmlFor="last month">Previous Month</label>
            </div>
          </div>
          <div className="item6">
            <div className="toggle-radio">
              <input
                type="radio"
                id="month to date"
                name="month"
                value="Month to Date"
                checked={value.month === "Month to Date"}
                onClick={() => handleRadioChange("Month to Date")}
                onChange={() => {}}
                disabled={isApplied}
              />
              <label htmlFor="month to date">Month to Date</label>
            </div>
          </div>
          <div className="item7">
            <div className="toggle-radio">
              <input
                type="radio"
                id="week to date"
                name="month"
                value="Week to Date"
                checked={value.month === "Week to Date"}
                onClick={() => handleRadioChange("Week to Date")}
                onChange={() => {}}
                disabled={isApplied}
              />
              <label htmlFor="week to date">Week to Date</label>
            </div>
          </div>
          <div className="item8">
            <div className="toggle-radio">
              <input
                type="radio"
                id="custom"
                name="month"
                value="Custom"
                checked={value.month === "Custom"}
                onClick={() => handleRadioChange("Custom")}
                onChange={() => {}}
                disabled={isApplied}
              />
              <label htmlFor="custom">Custom</label>
            </div>
          </div>
          {value.month === "Custom" && (
            <>
              <div className="item9">
                <FormInputs
                  type="date"
                  name="start_month"
                  value={value.start_month}
                  onChange={(e) =>
                    setValues({ ...value, start_month: e.target.value })
                  }
                  disabled={isApplied}
                />
              </div>
              <div className="item10">To</div>
              <div className="item11">
                <FormInputs
                  type="date"
                  name="end_month"
                  value={value.end_month}
                  onChange={(e) =>
                    setValues({ ...value, end_month: e.target.value })
                  }
                  disabled={isApplied}
                />
              </div>
            </>
          )}
        </div>
      </div>

      {/* Table Section */}
      <div style={{ position: "relative", marginTop: "20px" }}>
        <button
          style={{
            position: "absolute",
            top: "-1px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1,
            width: "60px",
            height: "10px",
            backgroundColor: "white",
            border: "none",
          }}
          onClick={() => {
            setIsExpanded(!isExpanded);
            setIsVisible(!isVisible);
          }}
        >
          <p style={{ fontSize: "20px", color: "black" }}>...</p>
        </button>
        <TableCompoenent
          headers={headers.map((header) => header.substring(2))}
          data={resultsData}
          searchPlaceholder="Search by Student Name..."
          isColumnDivVisible={isColumnDivVisible}
          setIsColumnDivVisible={setIsColumnDivVisible}
          dataClient={dataClient}
          ReportPageHeader={reportName}
          course={course}
          batch={getSelectedBatchName()}
          subject={getSelectedDppNames()}
          chapter={getSelectedSessionName()}
          dppName={""}
          student={getSelectedStudentRollNumbers()}
          date={
            from_date &&
            end_date &&
            dayjs(from_date).isValid() &&
            dayjs(end_date).isValid()
              ? `${dayjs(from_date).format("YYYY-MM-DD")} To ${dayjs(
                  end_date
                ).format("YYYY-MM-DD")}`
              : ""
          }
          isExpanded={isExpanded}
        />
      </div>
    </div>
  );
};

export default IncompleteDppReport;

























// import CustomSearchDropdown from "../../POP/FileComp5";
// import _ from "lodash";
// import { useSearchParams } from "react-router-dom";
// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import TableCompoenent from "./TableCompoenent";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import DropDownCB from "../components/SingleDropdwon";
// import FormInputs from "../DummyReportPage/FormInputs";
// import dayjs from "dayjs";
// import DropDownMultipleSelection from "../components/FieldsComponent";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Warning.png";
// import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";
// import { useNavigate } from "react-router-dom";

// const mapDataToDropdownFormat = (dataArray, idField, nameField) => {
//   return _.uniqBy(
//     dataArray.map((item) => ({
//       id: item[idField],
//       label: item[nameField],
//     })),
//     "id"
//   );
// };

// const IncompleteDppReport = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   pauseTimer,
//   resumeTimer,
//   dataClient,
//   setPagePath,
// }) => {
//   const dispatch = useDispatch();
//   const { coursesdata } = useSelector((state) => state.course);
//   const [resultsData, setResultsData] = useState([]);
//   const [headers, setHeaders] = useState([]);
//   const [isApplied, setIsApplied] = useState(false);
//   const [resetKey, setResetKey] = useState(0);
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [isVisible, setIsVisible] = useState(true);
//   const [disabled, setDisabled] = useState(false);
//   const [isExpanded, setIsExpanded] = useState(false);

//   // Dropdown data states
//   const [batchData, setBatchData] = useState([]);
//   const [studentData, setStudentData] = useState([]);
//   const [sessionData, setSessionData] = useState([]);
//   const [dppData, setDppData] = useState([]);

//   // Selected values states
//   const [selectedCourseId, setSelectedCourseId] = useState("");
//   const [selectedBatchId, setSelectedBatchId] = useState("");
//   const [selectedSessionId, setSelectedSessionId] = useState("");
//   const [selectedStudents, setSelectedStudents] = useState([]);
//   const [selectedDpps, setSelectedDpps] = useState([]);

//   // Search states
//   const [searchKey, setSearchKey] = useState("");
//   const [searchColumn, setSearchColumn] = useState("");

//   // Date range state
//   const [value, setValues] = useState({
//     month: "Month to Date",
//     start_month: "",
//     end_month: "",
//   });

//   const [searchParams] = useSearchParams();
//   const reportName = searchParams.get("reportName") || "Incomplete DPP Report";

//   const navigate = useNavigate();

//   // Add this with other dropdown data states
//   const [subjectData, setSubjectData] = useState([]);

//   // Add this with other selected values states
//   const [selectedSubjects, setSelectedSubjects] = useState([]);

//   // Fetch subject data based on course
//   const fetchSubjectData = async () => {
//     try {
//       if (!selectedCourseId) return;

//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-subjects-by-course/?course_id=${selectedCourseId}`,
//         {
//           method: "GET",
//           headers: {
//             accept: "application/json",
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const result = await response.json();

//       if (result && Array.isArray(result)) {
//         const formattedSubjects = result.map((subject) => ({
//           id: subject.subject_id,
//           label: subject.subject_name,
//         }));
//         setSubjectData(formattedSubjects);
//       }
//     } catch (error) {
//       console.error("Error fetching subject data:", error);
//     }
//   };

//   useEffect(() => {
//     setPagePath("Reports > Reports Dashboard > DPP Completion");
//   }, []);

//   // Fetch course data on mount
//   useEffect(() => {
//     dispatch(fetchCourseData());
//   }, [dispatch]);

//   // Fetch sessions on mount
//   useEffect(() => {
//     fetchSessionsData();
//   }, []);

//   // Fetch batch data when course changes
//   useEffect(() => {
//     if (selectedCourseId) {
//       fetchBatchData();
//       fetchSubjectData();
//     }
//     // Clear dependent dropdowns when course changes (except session - will be auto-set)
//     setSelectedBatchId("");
//     setSelectedStudents([]);
//     setSelectedSubjects([]);
//     setSelectedDpps([]);
//     setBatchData([]);
//     setSubjectData([]);
//     setStudentData([]);
//     setDppData([]);
//   }, [selectedCourseId]);

//   // Auto-select the most recent session (highest session_id) when course is selected
//   useEffect(() => {
//     if (selectedCourseId && sessionData.length > 0) {
//       // Find the session with the highest session_id
//       const mostRecentSession = sessionData.reduce((prev, current) =>
//         prev.id > current.id ? prev : current
//       );
//       setSelectedSessionId(mostRecentSession.id);
//     } else if (!selectedCourseId) {
//       setSelectedSessionId("");
//     }
//   }, [selectedCourseId, sessionData]);

//   // Clear batch, student, dpp when session changes
//   useEffect(() => {
//     setSelectedBatchId("");
//     setSelectedStudents([]);
//     setSelectedDpps([]);
//     setSelectedSubjects([]);
//     setStudentData([]);
//     setDppData([]);
//   }, [selectedSessionId]);

//   // Fetch student data and DPP data when batch changes
//   useEffect(() => {
//     if (selectedCourseId && selectedBatchId) {
//       fetchStudentData();
//       fetchDppData();
//     }
//     // Clear dependent dropdowns when batch changes
//     setSelectedStudents([]);
//     setSelectedSubjects([]);
//     setSelectedDpps([]);
//     setStudentData([]);
//     setDppData([]);
//   }, [selectedBatchId]);

//   // Filter batches based on selected session
//   const filteredBatchData = useMemo(() => {
//     if (!selectedSessionId) {
//       return batchData;
//     }
//     return batchData.filter((batch) => batch.session_id === selectedSessionId);
//   }, [batchData, selectedSessionId]);

//   // Fetch sessions list
//   const fetchSessionsData = async () => {
//     try {
//       const response = await fetch(`${FULL_API_BASE_URL}/get-sessions-list`, {
//         method: "GET",
//         headers: {
//           accept: "application/json",
//           "Content-Type": "application/json",
//         },
//       });

//       const result = await response.json();

//       if (result.status === 200 && result.data) {
//         const formattedSessions = result.data.map((session) => ({
//           id: session.session_id,
//           label: session.session_name,
//         }));
//         setSessionData(formattedSessions);
//       }
//     } catch (error) {
//       console.error("Error fetching sessions data:", error);
//     }
//   };

//   // Fetch batch data based on course
//   const fetchBatchData = async () => {
//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-batches-by-course/?course_id=${selectedCourseId}`,
//         {
//           method: "GET",
//           headers: {
//             accept: "application/json",
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const data = await response.json();

//       if (data && Array.isArray(data)) {
//         const formattedBatches = data.map((item) => ({
//           id: item.batch_id,
//           label: item.batch_name,
//           session_id: item.session_id,
//           session_name: item.session_name,
//         }));
//         setBatchData(formattedBatches);
//       }
//     } catch (error) {
//       console.error("Error fetching batch data:", error);
//     }
//   };

//   // Fetch student data based on course and batch
//   const fetchStudentData = useCallback(async () => {
//     try {
//       if (!selectedCourseId || !selectedBatchId) return;

//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey-v2/?course_id=${selectedCourseId}`,
//         {
//           method: "POST",
//           headers: {
//             accept: "application/json",
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             batch_ids: [selectedBatchId],
//             subject_ids: [],
//             chapter_ids: [],
//             assessment_ids: [],
//             student_ids: [],
//             search_key: searchKey,
//             search_column: searchColumn,
//           }),
//         }
//       );

//       const data = await response.json();

//       const uniqueStudents = _.uniqBy(data.student_list, "student_id");
//       setStudentData(
//         uniqueStudents.map((item) => ({
//           id: item.student_id,
//           student_name: item.student_name,
//           roll_number: item.roll_number,
//           batch_name: item.batch_name,
//         }))
//       );
//     } catch (error) {
//       console.error("Error fetching student data:", error);
//     }
//   }, [selectedCourseId, selectedBatchId, searchKey, searchColumn]);

//   // Fetch DPP data based on batch only
//   // const fetchDppData = async () => {
//   //   try {
//   //     if (!selectedBatchId) return;

//   //     const response = await fetch(
//   //       `${FULL_API_BASE_URL}/get-dpps-by-batch?batch_id=${selectedBatchId}`,
//   //       {
//   //         method: "GET",
//   //         headers: {
//   //           accept: "application/json",
//   //           "Content-Type": "application/json",
//   //         },
//   //       }
//   //     );

//   //     const result = await response.json();

//   //     if (result.status === 200 && result.data) {
//   //       const formattedDpps = result.data
//   //         .filter((dpp) => dpp.schedule_id)
//   //         .map((dpp) => ({
//   //           id: dpp.schedule_id,
//   //           label: dpp.assessment_name,
//   //         }));

//   //       setDppData(_.uniqBy(formattedDpps, "id"));
//   //     }
//   //   } catch (error) {
//   //     console.error("Error fetching DPP data:", error);
//   //   }
//   // };

//   const fetchDppData = async () => {
//     try {
//       if (!selectedBatchId) return;

//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-dpps-by-batch?batch_id=${selectedBatchId}`,
//         {
//           method: "GET",
//           headers: {
//             accept: "application/json",
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const result = await response.json();

//       if (result.status === 200 && result.data) {
//         const formattedDpps = result.data
//           .filter((dpp) => dpp.schedule_id)
//           .map((dpp) => ({
//             id: dpp.schedule_id,
//             label: dpp.assessment_name,
//             subject_id: dpp.subject_id, // ← store subject_id
//           }));

//         setDppData(_.uniqBy(formattedDpps, "id"));
//       }
//     } catch (error) {
//       console.error("Error fetching DPP data:", error);
//     }
//   };

//   const filteredDppData = useMemo(() => {
//     if (!selectedSubjects || selectedSubjects.length === 0) {
//       return dppData;
//     }
//     return dppData.filter((dpp) => selectedSubjects.includes(dpp.subject_id));
//   }, [dppData, selectedSubjects]);

//   useEffect(() => {
//     setSelectedDpps([]);
//   }, [selectedSubjects]);

//   const handleDropdownClose = () => {
//     if (selectedCourseId && selectedBatchId) {
//       fetchStudentData();
//     }
//   };

//   const handleSearchKeyChange = (key, dropdownType) => {
//     if (key.length >= 3 && dropdownType === "student") {
//       setSearchKey(key);
//       setSearchColumn(dropdownType);
//     } else {
//       setSearchKey("");
//       setSearchColumn("");
//     }
//   };

//   // Handle radio button click - allows deselection
//   const handleRadioChange = (selectedValue) => {
//     if (value.month === selectedValue) {
//       setValues({ ...value, month: "" });
//     } else {
//       setValues({ ...value, month: selectedValue });
//     }
//   };

//   // Calculate dates based on selected option
//   const calculateDates = () => {
//     const today = dayjs();
//     let from_date = "";
//     let end_date = "";

//     if (!value.month) {
//       return { from_date: "", end_date: "" };
//     }

//     end_date = today.format("YYYY-MM-DD");

//     switch (value.month) {
//       case "Last Month":
//         from_date = today
//           .subtract(1, "month")
//           .startOf("month")
//           .format("YYYY-MM-DD");
//         end_date = today
//           .subtract(1, "month")
//           .endOf("month")
//           .format("YYYY-MM-DD");
//         break;
//       case "Month to Date":
//         from_date = today.startOf("month").format("YYYY-MM-DD");
//         break;
//       case "Week to Date":
//         from_date = today.startOf("week").format("YYYY-MM-DD");
//         break;
//       case "Custom":
//         from_date = value.start_month;
//         end_date = value.end_month;
//         break;
//       default:
//         from_date = "";
//         end_date = "";
//         break;
//     }
//     return { from_date, end_date };
//   };

//   const { from_date, end_date } = calculateDates();

//   // Handle Apply/Reset button click
//   // const handleApplyOrReset = async () => {
//   //   if (isApplied) {
//   //     setResultsData([]);
//   //     setHeaders([]);
//   //     setIsApplied(false);
//   //     setIsColumnDivVisible(false);
//   //     setDisabled(false);
//   //     setResetKey((prevKey) => prevKey + 1);

//   //     setValues((prevValues) => ({
//   //       ...prevValues,
//   //       month: prevValues.month,
//   //       start_month: prevValues.start_month,
//   //       end_month: prevValues.end_month,
//   //     }));
//   //   } else {
//   //     // Validation: Check if required fields are selected
//   //   if (!selectedCourseId || !selectedSessionId || !selectedBatchId) {
//   //     const missingFields = [];
//   //     if (!selectedCourseId) missingFields.push("Course");
//   //     if (!selectedSessionId) missingFields.push("Session");
//   //     if (!selectedBatchId) missingFields.push("Batch");

//   //     const errorMessage = `Please select ${missingFields.join(", ")} before applying.`;

//   //     setIsMessageBoxVisible(true);
//   //     setMessageBox(
//   //       <div
//   //         className="Container-messageBOX"
//   //         onMouseEnter={pauseTimer}
//   //         onMouseLeave={resumeTimer}
//   //       >
//   //         <div className="messagebox-insider1">
//   //           <div className="loader-tc"></div>
//   //           <span>{errorMessage}</span>
//   //         </div>
//   //       </div>
//   //     );
//   //     setActiveImg(ErrorImg);
//   //     return; // Exit early without making the API call
//   //   }
//   //     setIsApplied(true);
//   //     setDisabled(true);

//   //     const { from_date, end_date } = calculateDates();

//   //     const requestBody = {};

//   //     if (selectedBatchId) {
//   //       requestBody.batch_ids = [selectedBatchId];
//   //     }

//   //     if (selectedStudents.length > 0) {
//   //       requestBody.student_ids = selectedStudents;
//   //     }

//   //     if (selectedDpps.length > 0) {
//   //       requestBody.dpp_schedule_ids = selectedDpps;
//   //     }

//   //     if (selectedSessionId) {
//   //       requestBody.session_ids = [selectedSessionId];
//   //     }

//   //     if (from_date) {
//   //       requestBody.from_date = from_date;
//   //     }

//   //     if (end_date) {
//   //       requestBody.end_date = end_date;
//   //     }

//   //     try {
//   //       const response = await fetch(
//   //         `${FULL_API_BASE_URL}/incomplete-dpp-report`,
//   //         {
//   //           method: "POST",
//   //           headers: {
//   //             accept: "application/json",
//   //             "Content-Type": "application/json",
//   //           },
//   //           body: JSON.stringify(requestBody),
//   //         }
//   //       );

//   //       const result = await response.json();

//   //       if (result.status === 200 && result.data && result.data.length > 1) {
//   //         setHeaders(result.data[0]);
//   //         setResultsData(result.data.slice(1));
//   //       } else {
//   //         setResultsData([]);
//   //         setIsMessageBoxVisible(true);
//   //         setMessageBox(
//   //           <div
//   //             className="Container-messageBOX"
//   //             onMouseEnter={pauseTimer}
//   //             onMouseLeave={resumeTimer}
//   //           >
//   //             <div className="messagebox-insider1">
//   //               <div className="loader-tc"></div>
//   //               <span>No data found for the selected filters.</span>
//   //             </div>
//   //           </div>
//   //         );
//   //         setActiveImg(InterogativeImg);
//   //       }
//   //     } catch (error) {
//   //       setResultsData([]);
//   //       setIsMessageBoxVisible(true);
//   //       setMessageBox(
//   //         <div
//   //           className="Container-messageBOX"
//   //           onMouseEnter={pauseTimer}
//   //           onMouseLeave={resumeTimer}
//   //         >
//   //           <div className="messagebox-insider1">
//   //             <div className="loader-tc"></div>
//   //             <span>{error.message || "Failed to generate report"}</span>
//   //           </div>
//   //         </div>
//   //       );
//   //       setActiveImg(ErrorImg);
//   //     }
//   //   }
//   // };

//   const [isLoading, setIsLoading] = useState(false);

//   const handleApplyOrReset = async () => {
//     if (isApplied) {
//       setResultsData([]);
//       setHeaders([]);
//       setIsApplied(false);
//       setIsLoading(false);
//       setIsColumnDivVisible(false);
//       setDisabled(false);
//       setIsMessageBoxVisible(false);
//       setResetKey((prevKey) => prevKey + 1);

//       setValues((prevValues) => ({
//         ...prevValues,
//         month: prevValues.month,
//         start_month: prevValues.start_month,
//         end_month: prevValues.end_month,
//       }));
//     } else {
//       // Validation: Check if required fields are selected
//       if (!selectedCourseId || !selectedSessionId || !selectedBatchId) {
//         const missingFields = [];
//         if (!selectedCourseId) missingFields.push("Course");
//         if (!selectedSessionId) missingFields.push("Session");
//         if (!selectedBatchId) missingFields.push("Batch");

//         const errorMessage = `Please select ${missingFields.join(
//           ", "
//         )} before applying.`;

//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div
//             className="Container-messageBOX"
//             onMouseEnter={pauseTimer}
//             onMouseLeave={resumeTimer}
//           >
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{errorMessage}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         return;
//       }

//       // Show loading message
//       setIsLoading(true);
//       setIsApplied(true);
//       setDisabled(true);
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div
//           className="Container-messageBOX"
//           onMouseEnter={pauseTimer}
//           onMouseLeave={resumeTimer}
//         >
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Loading data, please wait...</span>
//           </div>
//         </div>
//       );
//       setActiveImg(false);

//       const { from_date, end_date } = calculateDates();

//       const requestBody = {};

//       if (selectedBatchId) {
//         requestBody.batch_ids = [selectedBatchId];
//       }

//       if (selectedStudents.length > 0) {
//         requestBody.student_ids = selectedStudents;
//       }

//       if (selectedDpps.length > 0) {
//         requestBody.dpp_schedule_ids = selectedDpps;
//       }

//       if (selectedSessionId) {
//         requestBody.session_ids = [selectedSessionId];
//       }

//       if (from_date) {
//         requestBody.from_date = from_date;
//       }

//       if (end_date) {
//         requestBody.end_date = end_date;
//       }

//       try {
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/incomplete-dpp-report`,
//           {
//             method: "POST",
//             headers: {
//               accept: "application/json",
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify(requestBody),
//           }
//         );

//         const result = await response.json();

//         if (
//           result.status === 200 &&
//           result.data?.data &&
//           result.data.data.length > 1
//         ) {
//           setHeaders(result.data.data[0]);
//           setResultsData(result.data.data.slice(1));
//           setIsLoading(false);
//           setIsMessageBoxVisible(false);
//         } else {
//           setIsLoading(false);
//           setResultsData([]);
//           setIsMessageBoxVisible(true);
//           setMessageBox(
//             <div
//               className="Container-messageBOX"
//               onMouseEnter={pauseTimer}
//               onMouseLeave={resumeTimer}
//             >
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>No data found for the selected filters.</span>
//               </div>
//             </div>
//           );
//           setActiveImg(InterogativeImg);
//         }
//       } catch (error) {
//         setIsLoading(false);
//         setResultsData([]);
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div
//             className="Container-messageBOX"
//             onMouseEnter={pauseTimer}
//             onMouseLeave={resumeTimer}
//           >
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{error.message || "Failed to generate report"}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//       }
//     }
//   };

//   const dropdownStyle = isApplied
//     ? { opacity: 0.5, pointerEvents: "none" }
//     : { opacity: 1, pointerEvents: "auto" };

//   const course =
//     coursesdata && coursesdata.length > 0
//       ? coursesdata.find((course) => course.course_id === selectedCourseId)
//           ?.course_description || ""
//       : "";

//   const getSelectedBatchName = () => {
//     if (!selectedBatchId) return "All";
//     const batch = batchData.find((batch) => batch.id === selectedBatchId);
//     return batch ? batch.label : "All";
//   };

//   const getSelectedStudentRollNumbers = () => {
//     if (selectedStudents.length === 0) return "All";
//     const rollNumbers = studentData
//       .filter((student) => selectedStudents.includes(student.id))
//       .map((student) => student.roll_number);
//     const rollNumbersString = rollNumbers.join(", ");
//     const maxLength = 129;
//     if (rollNumbersString.length > maxLength) {
//       return "Multiple";
//     }
//     return rollNumbersString;
//   };

//   const getSelectedSessionName = () => {
//     if (!selectedSessionId) return "All";
//     const session = sessionData.find(
//       (session) => session.id === selectedSessionId
//     );
//     return session ? session.label : "All";
//   };

//   const getSelectedDppNames = () => {
//     if (selectedDpps.length === 0) return "All";
//     const dppNames = dppData
//       .filter((dpp) => selectedDpps.includes(dpp.id))
//       .map((dpp) => dpp.label);
//     const dppNamesString = dppNames.join(", ");
//     const maxLength = 129;
//     if (dppNamesString.length > maxLength) {
//       return "Multiple";
//     }
//     return dppNamesString;
//   };

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "36.5px",
//         marginBottom: "40px",
//       }}
//     >
//       <div style={{ position: "sticky", top: "0" }}>
//         <div className="Header-up">
//           <span
//             style={{
//               color: "#2F2E40",
//               fontSize: "30px",
//               textTransform: "capitalize",
//             }}
//           >
//             {reportName}
//           </span>
//           <div
//             className="testreportcard-header-btn-container"
//             style={{ marginRight: "30px" }}
//           >
//             <button
//               className="testreportcard-cancel-btn"
//               onClick={() => {
//                 navigate("/report_management");
//                 setPagePath("Reports > Reports Dashboard");
//               }}
//             >
//               CANCEL
//             </button>

//             <button
//               className="testreportcard-create-btn"
//               onClick={handleApplyOrReset}
//               // style={{
//               //   opacity: isLoading ? 0.6 : 1,
//               //   cursor: isLoading ? "not-allowed" : "pointer",
//               // }}
//             >
//               {isApplied ? "RESET" : "APPLY"}
//             </button>
//           </div>
//         </div>
//       </div>

//       <div style={{ display: isVisible ? "block" : "none", marginTop: "1vh" }}>
//         {/* Row 1: Course, Session, Batch */}
//         <div className="row-cs-uni">
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`course_${resetKey}`}
//           >
//             <DropDownCB
//               label="Course"
//               style={{ width: "13.5vw" }}
//               selected={selectedCourseId}
//               setSelected={setSelectedCourseId}
//               options={
//                 coursesdata
//                   ? coursesdata.map((course) => ({
//                       id: course.course_id,
//                       label: course.course_description,
//                     }))
//                   : []
//               }
//               isRequired={true}
//             />
//           </div>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`session_${resetKey}`}
//           >
//             <DropDownCB
//               label="Select Session"
//               style={{ width: "13.5vw" }}
//               selected={selectedSessionId}
//               setSelected={setSelectedSessionId}
//               options={sessionData}
//               isRequired={true}
//             />
//           </div>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`batch_${resetKey}`}
//           >
//             <DropDownCB
//               label="Select Batch"
//               style={{ width: "13.5vw" }}
//               selected={selectedBatchId}
//               setSelected={setSelectedBatchId}
//               options={filteredBatchData}
//               disabled={!selectedCourseId}
//               isRequired={true}
//             />
//           </div>
//         </div>

//         {/* Row 2: Student, DPP */}
//         <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`subject_${resetKey}`}
//           >
//             <DropDownMultipleSelection
//               width="13.5vw"
//               label="Select Subject"
//               selected={selectedSubjects}
//               setSelected={setSelectedSubjects}
//               options={subjectData}
//               customWidth="100%"
//               isRequired={false}
//               showSelectAll={true}
//               onDropdownClose={() => {}}
//               disabled={!selectedCourseId}
//             />
//           </div>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`student_${resetKey}`}
//           >
//             <CustomSearchDropdown
//               label="Select Student"
//               optionsData={studentData}
//               selected={selectedStudents}
//               setSelected={setSelectedStudents}
//               placeholder="Search for Students..."
//               headers={["Student Name", "Roll Number", "Batch Name"]}
//               optionFields={{
//                 option1: "student_name",
//                 option2: "roll_number",
//                 option3: "batch_name",
//               }}
//               onDropdownClose={handleDropdownClose}
//               onSearchKeyChange={(key) => handleSearchKeyChange(key, "student")}
//               customwidth="25vw"
//               dropdownWidth="13.5vw"
//             />
//           </div>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`dpp_${resetKey}`}
//           >
//             <DropDownMultipleSelection
//               width="13.5vw"
//               label="Select DPP"
//               selected={selectedDpps}
//               setSelected={setSelectedDpps}
//               // options={dppData}
//               options={filteredDppData}
//               customWidth="100%"
//               isRequired={false}
//               showSelectAll={true}
//               onDropdownClose={() => {}}
//               disabled={!selectedBatchId}
//             />
//           </div>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//           >
//             {/* Empty placeholder */}
//           </div>
//         </div>

//         {/* Row 3: Date Range Radio Buttons */}
//         <div
//           className="grid-container-radio-button"
//           style={{ marginTop: "1vh", height: "35px", ...dropdownStyle }}
//         >
//           <div className="item5">
//             <div className="toggle-radio">
//               <input
//                 type="radio"
//                 id="last month"
//                 name="month"
//                 value="Last Month"
//                 checked={value.month === "Last Month"}
//                 onClick={() => handleRadioChange("Last Month")}
//                 onChange={() => {}}
//                 disabled={isApplied}
//               />
//               <label htmlFor="last month">Previous Month</label>
//             </div>
//           </div>
//           <div className="item6">
//             <div className="toggle-radio">
//               <input
//                 type="radio"
//                 id="month to date"
//                 name="month"
//                 value="Month to Date"
//                 checked={value.month === "Month to Date"}
//                 onClick={() => handleRadioChange("Month to Date")}
//                 onChange={() => {}}
//                 disabled={isApplied}
//               />
//               <label htmlFor="month to date">Month to Date</label>
//             </div>
//           </div>
//           <div className="item7">
//             <div className="toggle-radio">
//               <input
//                 type="radio"
//                 id="week to date"
//                 name="month"
//                 value="Week to Date"
//                 checked={value.month === "Week to Date"}
//                 onClick={() => handleRadioChange("Week to Date")}
//                 onChange={() => {}}
//                 disabled={isApplied}
//               />
//               <label htmlFor="week to date">Week to Date</label>
//             </div>
//           </div>
//           <div className="item8">
//             <div className="toggle-radio">
//               <input
//                 type="radio"
//                 id="custom"
//                 name="month"
//                 value="Custom"
//                 checked={value.month === "Custom"}
//                 onClick={() => handleRadioChange("Custom")}
//                 onChange={() => {}}
//                 disabled={isApplied}
//               />
//               <label htmlFor="custom">Custom</label>
//             </div>
//           </div>
//           {value.month === "Custom" && (
//             <>
//               <div className="item9">
//                 <FormInputs
//                   type="date"
//                   name="start_month"
//                   value={value.start_month}
//                   onChange={(e) =>
//                     setValues({ ...value, start_month: e.target.value })
//                   }
//                   disabled={isApplied}
//                 />
//               </div>
//               <div className="item10">To</div>
//               <div className="item11">
//                 <FormInputs
//                   type="date"
//                   name="end_month"
//                   value={value.end_month}
//                   onChange={(e) =>
//                     setValues({ ...value, end_month: e.target.value })
//                   }
//                   disabled={isApplied}
//                 />
//               </div>
//             </>
//           )}
//         </div>
//       </div>

//       {/* Table Section */}
//       <div style={{ position: "relative", marginTop: "20px" }}>
//         <button
//           style={{
//             position: "absolute",
//             top: "-1px",
//             left: "50%",
//             transform: "translateX(-50%)",
//             zIndex: 1,
//             width: "60px",
//             height: "10px",
//             backgroundColor: "white",
//             border: "none",
//           }}
//           onClick={() => {
//             setIsExpanded(!isExpanded);
//             setIsVisible(!isVisible);
//           }}
//         >
//           <p style={{ fontSize: "20px", color: "black" }}>...</p>
//         </button>
//         <TableCompoenent
//           headers={headers.map((header) => header.substring(2))}
//           data={resultsData}
//           searchPlaceholder="Search by Student Name..."
//           isColumnDivVisible={isColumnDivVisible}
//           setIsColumnDivVisible={setIsColumnDivVisible}
//           dataClient={dataClient}
//           ReportPageHeader={reportName}
//           course={course}
//           batch={getSelectedBatchName()}
//           subject={getSelectedDppNames()}
//           chapter={getSelectedSessionName()}
//           dppName={""}
//           student={getSelectedStudentRollNumbers()}
//           date={
//             from_date &&
//             end_date &&
//             dayjs(from_date).isValid() &&
//             dayjs(end_date).isValid()
//               ? `${dayjs(from_date).format("YYYY-MM-DD")} To ${dayjs(
//                   end_date
//                 ).format("YYYY-MM-DD")}`
//               : ""
//           }
//           isExpanded={isExpanded}
//         />
//       </div>
//     </div>
//   );
// };

// export default IncompleteDppReport;
